import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';


export const ModalImprimirOpObsequio = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtTodos = useRef();

  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [activate, setActivate] = useState(false);
  const [todasfechas, setTodasfechas] = useState(0);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });


  const blanquear = () => {
    setActivate(false);
    setDesde('');
    setHasta('');
    setTodasfechas(0);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {

      if (txtDesde.current.value === "" || txtHasta.current.value === "") {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no deben ir Vacias !', icono: 'informacion' });
        txtDesde.current.focus()
        sigue = false
      } else {

        imprimirRecibo();

      }

    }

  }

  const imprimirRecibo = () => {

    var reporte = 'OperacionesInventarioObsequioDonaciones';
    let fechas = "";

    if (todasfechas !== 0) {
      fechas = '';
    } else {
      fechas = 'and n.fechatipomovimiento between ' + "'" + desde + "'" + ' and ' + "'" + hasta + "'";
    }

    window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&desde=" + desde + "&hasta=" + hasta + "&condi=" + fechas, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

  }


  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const onChange = (e) => {

    if (e.target.name === 'todos') {
      if (e.target.checked) {
        setTodasfechas(1);
        setDesde('');
        setHasta('');
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
      } else {
        let fh = moment(fechasistema).format('DD-MM-YYYY');
        setTodasfechas(0);
        setDesde(fh);
        setHasta(fh);
      }
    }

    if (e.target.name === "desde" && todasfechas !== 1) {
      let desdec = moment(e.target.value).format('DD-MM-YYYY');
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde(desdec);
      }
    } else if (e.target.name === "hasta") {
      let hastac = moment(e.target.value).format('DD-MM-YYYY');
      setHasta(hastac);
    }

  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
        setDesde('');
        setHasta('');
        txtTodos.current.checked = true;
        setTodasfechas(1);

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>{"Operaciones de Inventario Obsequio/Donaciones"}</h3></div>

        <a href='#' ref={btnSalir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto m-0 border-azul px-1">

            <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-8 px-3 mb-1'>
                <div className="form-check">
                  <input className="form-check-input" ref={txtTodos} onChange={onChange} name='todos' type="checkbox" value="" id="flexCheckDefault" />
                  <label className="form-check-label" for="flexCheckDefault">
                    TODOS
                  </label>
                </div>
              </div>

              <div className='col-6 px-1 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">DESDE:</label>
                  <input type="date" ref={txtDesde} disabled={todasfechas !== 0 ? true : false} name='desde' onChange={onChange} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-6 px-1 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">HASTA:</label>
                  <input type="date" ref={txtHasta} disabled={todasfechas !== 0 ? true : false} name='hasta' onChange={onChange} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div>

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={props.ope !== 0 ? false : true} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/almacen/imprimirOpObsequio.js